export default "__VITE_ASSET__ZwLLJWWn__"